/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomObjectsSettings from 'components/SettingsComponents/CustomObjectsSettings';
import { useTheme } from "@mui/material/styles";

export default function CustomObjectsSettingsPage() {
  const navigate = useNavigate();
  const isV2 = useTheme()?.pearlUi === "v2";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={isV2 ? 3 : 4} pb={6}>
        {/* v2: the Custom Objects page header below names the page. */}
        {!isV2 && (
        <MDBox display="flex" alignItems="center" gap={1} mb={3}>
          <IconButton onClick={() => navigate('/settings')}>
            <ArrowBack />
          </IconButton>
          <MDTypography variant="h4" fontWeight="medium">
            Settings
          </MDTypography>
        </MDBox>
        )}
        <CustomObjectsSettings />
      </MDBox>
    </DashboardLayout>
  );
}
